import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardError, Loading, CardListTurnHours } from '../../components';
import { getTurnDates } from '../../redux/actions/turnActions';

const TurnsDate = () => {
  const dispatch = useDispatch();
  // eslint-disable-next-line max-len
  const { dateTurn, isLoading } = useSelector((state) => state.turnReducer);
  const { healthInsurance } = useSelector(
    (state) => state.healthInsuranceReducer
  );
  const { doctor } = useSelector((state) => state.doctorReducer);
  useEffect(() => {
    dispatch(getTurnDates(doctor.id, healthInsurance.id));
  }, []);

  if (isLoading) return <Loading />;

  if (dateTurn.length === 0) {
    return <CardError text="No hay fechas disponibles" />;
  }
  return (
    <CardListTurnHours data={dateTurn} type="turn" title="Elija una fecha" />
  );
};

export default TurnsDate;
